module.exports = __webpack_public_path__ + "static/img/Four of Pentacles.ffbc18a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Four of Pentacles.jpg
// module id = 1271
// module chunks = 0